import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { Skeleton } from "designV2/components/Skeleton";
import AddCar from "./AddCar";
import "superAdminViews/users/superPeople.css";

const GET_CAR = gql`
  query getCarForEdit($_id: ID) {
    getCarsByAdmin(pagination: { limit: 1, skip: 0 }, filters: { _id: $_id }) {
      _id
      plate
      manufacturingYear
      description
      registrationDocumentUrl
      ride
      delivery
      brand {
        _id
        name
      }
      model {
        _id
        name
      }
      color {
        _id
        name
      }
      carType {
        _id
        type
      }
      pictures {
        inner {
          url
        }
        outer {
          url
        }
      }
      insurance {
        insuranceImageUrl
        expireDate
      }
      carOptions {
        inHurry
        orderingForSomeoneElse
        pet
        bagsWithMe
        reserved
        airConditioner
        welcomeSign
        driverAssistant
        withInfant
        waitTimesInMinutes
        tipValue
      }
    }
  }
`;

const EditCar = ({ carId }) => {
  const { loading, error, data } = useQuery(GET_CAR, {
    variables: { _id: carId },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page superPeoplePage">
        <main className="main">
          <PageHeader title="Edit vehicle" />
          <Skeleton height={280} />
          <Skeleton height={220} />
        </main>
      </div>
    );
  }

  const car = data && data.getCarsByAdmin && data.getCarsByAdmin[0];
  if (error || !car) {
    return <ErrorPage />;
  }

  return <AddCar car={car} carId={carId} />;
};

export default EditCar;
